/**
 * @component {"type":"Statistics","version":"1.0"}
 */

 // https://jsfiddle.net/uoLfv79b/
 // https://jsfiddle.net/prewiseDevelopers/0avvwsL9/

 // https://bl.ocks.org/mbostock/3887235

define('component-statistics',['knockout', 'helpers', 'load-modules', 'user-answers'], function(ko, helpers, loadModules, UserAnswers) {

    return function(parentVM, dataContext) {
        var self = this,
            entityVM = parentVM.entity,
            taskVM = parentVM.task,
            userVM = parentVM.user,
            trainingVM = parentVM.training,
            textAnswers = [],
            items = [],
            timeoutID;

        self.answersShowNo = ko.observable(0);

        self.placeholder = ko.observable('');

        self.loader = ko.observable(false);

        self.empty = ko.observable('No answers exist');
        self.noAnswersAvailable = ko.observable(false);

        self.pieEnabled = ko.observable(true);
        self.pieLabel = ko.observable('');

        self.items = ko.computed(function() {
            var ID = entityVM.ID();

            items = [];
        });

        self.progressEnabled = ko.computed(function() {
            return entityVM.containsStatistics() && taskVM.isAnswered() && !self.noAnswersAvailable();
        }).extend({rateLimit: 0});

        self.colors = ko.computed(function() {
            var colors = ['#00659A', '#0087CD', '#33B132', '#DD3730', '#00111a', '#00334d', '#164e16', '#7a1814', '#1ab0ff', '#9addff', '#86dd86', '#efa19d'],
                content = helpers.component.getContent(entityVM.componentsJSON(), 'Statistics'),
                arr = helpers.component.parseProp(content, 'colors', 'StatisticsColor') || [];

            arr.forEach(function(color, i) {
                colors[i] = color.code;
            });

            return colors;
        });

        self.getColor = function(i) {
            var colors = self.colors();

            i = (i < colors.length) ? i : i % colors.length;

            return colors[i];
        };

        self.type = ko.computed(function() {
            var entityContent = entityVM.entityContent(),
                typeID = entityContent.typeID,
                content = helpers.component.getContent(entityContent.componentsJSON, 'Statistics'),
                displayMode = entityContent.displayMode;

            self.pieLabel('');
            self.pieEnabled(true);

            if (!Object.keys(content).length || !entityVM.containsStatistics()) {
                return false;
            }

            self.placeholder(content.placeholder);

            self.noAnswersAvailable(false);
            self.empty(content.empty);

            switch(typeID) {
            case 12:
                return 'open';
            case 13:
                if (displayMode === 2 || displayMode === 4) {
                    var pie = helpers.component.parseProp(content, 'pie', 'StatisticsPie');

                    if (pie[0] && pie[0].enabled === false) {
                        self.pieEnabled(false);
                    } else {
                        loadModules({modules: ['graph']});
                    }

                    return 'pie';
                }
                return 'chart';
            case 14:
                if (displayMode === 2) {
                    return 'progress';
                }
                return '';
            default:
                return '';
            }
        });

        self.cssClass = ko.computed(function() {
            var type = self.type(),
                res = (type === 'progress') ? '' : 'component-container';

            if (type === 'pie') {
                var entityContent = entityVM.entityContent(),
                    content = helpers.component.getContent(entityContent.componentsJSON, 'Statistics'),
                    pie = helpers.component.parseProp(content, 'pie', 'StatisticsPie');

                if (pie[0] && pie[0].enabled === false) {
                    return 'hidden';
                }
            }

            return res + ' statistics-' + type + '-container';
        });

        self.answersAddNo = ko.observable(3);

        self.openUserAnswer = ko.observable(true);

        self.openUsername = ko.observable('first');

        self.openHeader = ko.observable('Here\'s what others have answered');

        self.openFooter = ko.observable('Show more');

        self.openLabel = ko.observable('My answer can be anonymously published among other users answers');

        self.cssClassOpen = ko.computed(function() {
            var res = '';

            if (self.openHeader() !== '') {
                res += ' statistics-open-wrap-header';
            }

            if (self.answersShowNo() < textAnswers.length && self.openFooter() !== '') {
                res += ' statistics-open-wrap-footer';
            }

            return res;
        });

        self.listHTML = ko.computed(function() {
            var res = '',
                no = self.answersShowNo(),
                answer,
                username = self.openUsername(),
                user = {
                    firstname: '',
                    lastname: '',
                    nickname: ''
                },
                getAuthor = function(username, user) {
                    var res = '';

                    switch(username) {
                    case 'first':
                        res += '<br><b>- ' + user.firstname + '</b>';
                        break;
                    case 'full':
                        res += '<br><b>- ' + user.firstname + ' ' + user.lastname + '</b>';
                        break;
                    case 'nickfirst':
                        if (user.nickname) {
                            res += '<br><b>- ' + user.nickname + '</b>';
                        } else {
                            res += '<br><b>- ' + user.firstname + '</b>';
                        }
                        break;
                    case 'nickfull':
                        if (user.nickname) {
                            res += '<br><b>- ' + user.nickname + '</b>';
                        } else {
                            res += '<br><b>- ' + user.firstname + ' ' + user.lastname + '</b>';
                        }
                        break;
                    default:
                    }

                    return res;
                },
                getUserAnswer = function(userAnswer) {
                    var answers = userAnswer.answers || [];

                    return (answers[0] && answers[0].answerText) ? answers[0].answerText : '';
                };

            if (no === 0 || !textAnswers.length || taskVM.isEnabled()) {
                return res;
            }

            if (no > textAnswers.length) {
                no = textAnswers.length;
            }

            res += '<ul class="statistics-open-list">';

            var ID = entityVM.ID(),
                userAnswers = new UserAnswers();

            if (self.openUserAnswer() && userAnswers.isAnswerPublic(ID)) {

                user.firstname = userVM.firstName();
                user.lastname = userVM.lastName();
                user.nickname = userVM.nickname();

                res += '<li>';
                res += getUserAnswer(userAnswers.getUserAnswer(ID));
                res += getAuthor(username, user);
                res += '</li>';
            }

            for (var i = 0; i < no; i++) {
                answer = textAnswers[i];

                user.firstname = (answer.userData && answer.userData.userFirstName) ? answer.userData.userFirstName : '';
                user.lastname = (answer.userData && answer.userData.userLastName) ? answer.userData.userLastName : '';
                user.nickname = (answer.userData && answer.userData.userNickname) ? answer.userData.userNickname : '';

                res += '<li>' + answer.taskAnswerText;
                res += getAuthor(username, user);
                res += '</li>';
            }

            res += '</ul>';

            return res;
        });

        ko.bindingHandlers.getSocialStatistics = {
            update: function() {
                self.loader(false);

                if (taskVM.isEnabled() && !taskVM.isAnswered()) {
                    return;
                }

                self.loader(true);

                var ID = entityVM.ID(),
                    content = helpers.component.getContent(entityVM.componentsJSON(), 'Statistics'),
                    open = helpers.component.parseProp(content, 'open', 'StatisticsOpen'),
                    answersShowNo = 0,
                    userAnswers = new UserAnswers();

                if (open[0]) {
                    answersShowNo = open[0].answersShowNo;
                    self.answersAddNo(open[0].answersAddNo);
                    self.openHeader(open[0].header);
                    self.openFooter(open[0].footer);
                    self.openUserAnswer(open[0].current);
                    self.openUsername(open[0].username);
                    self.openLabel(open[0].label);
                } else {
                    answersShowNo = 3;
                }

                if (self.openUserAnswer() && userAnswers.isAnswerPublic(ID)) {
                    answersShowNo--;
                }

                var options = {
                    taskID: ID,
                    inClass: !!content.inClass,
                    includeUserData: true,
                    order: 3
                };

                self.answersShowNo(0);

                setTimeout(function() {

                    dataContext.getStatistics(options).then(function(res) {
                        self.loader(false);

                        if (!res) {
                            self.noAnswersAvailable(true);
                            return;
                        }

                        textAnswers = res.textAnswers;
                        self.answersShowNo(answersShowNo);

                    }).catch(function(err) {
                        if (dataContext.debugMode) {
                            console.dir(err);
                        }
                    });

                }, 50);
            }
        };

        ko.bindingHandlers.getPieStatistics = {
            update: function(container, valueAccessor) {
                var data = ko.unwrap(valueAccessor());

                if (taskVM.isEnabled() && !taskVM.isAnswered()) {
                    return;
                }

                container.innerHTML = '';

                items.push({
                    ID: data.ID,
                    container: container
                });

                if (timeoutID) {
                    clearTimeout(timeoutID)
                }

                timeoutID = setTimeout(function() {
                    getStatistics('pie', items)
                }, 50);
            }
        };

        ko.bindingHandlers.getProgressStatistics = {
            update: function(container, valueAccessor) {
                var data = ko.unwrap(valueAccessor()),
                    inner = (container || document).querySelector('.js-statistics-progress-inner');

                if (taskVM.isEnabled() && !taskVM.isAnswered()) {
                    return;
                }

                container.style.width = '0';

                if (inner) {
                    inner.innerHTML = '';
                }

                items.push({
                    ID: data.ID,
                    questionID: data.questionID,
                    container: container
                });

                if (timeoutID) {
                    clearTimeout(timeoutID)
                }

                timeoutID = setTimeout(function() {
                    getStatistics('progress', items)
                }, 50);
            }
        }

        ko.bindingHandlers.getChartStatistics = {
            update: function(container, valueAccessor) {
                var data = ko.unwrap(valueAccessor()),
                    inner = (container || document).querySelector('.js-statistics-chart-inner');


                container.style.width = '0';

                if (inner) {
                    inner.innerHTML = '';
                }

                if (taskVM.isEnabled() && !taskVM.isAnswered()) {
                    return;
                }

                items.push({
                    ID: data.ID,
                    container: container,
                    inner: inner
                });

                if (timeoutID) {
                    clearTimeout(timeoutID)
                }

                timeoutID = setTimeout(function() {
                    getStatistics('chart', items)
                }, 50);
            }
        }


        self.addMoreAnswers = function() {
            var no = parseInt(self.answersShowNo()),
                add = parseInt(self.answersAddNo());

            self.answersShowNo(no + add);
        };

        function getStatistics(type, results) {
            var content = helpers.component.getContent(entityVM.componentsJSON(), 'Statistics');

            if (!Object.keys(content).length || !results.length || !taskVM.isAnswered()) {
                items = [];
                return;
            }

            self.loader(true);

            if (type === 'pie') {
                var pie = helpers.component.parseProp(content, 'pie', 'StatisticsPie'),
                    transition = (pie[0]) ? parseInt(pie[0].transition) : 400;

                if (pie[0] && pie[0].enabled === false) {
                    transition = 0;
                }
            }

            var options = {
                taskID: entityVM.ID(),
                inClass: !!content.inClass,
                includeUserData: false,
                order: 0
            };

            dataContext.getStatistics(options).then(function(res) {
                self.loader(false);

                if (!res) {
                    self.noAnswersAvailable(true);
                    return;
                }

                if (type === 'chart') {

                    results.forEach(function(r) {
                        var total = res.answeredUsersCount || 0,
                            statistics = (Array.isArray(res.answerStatistics)) ? res.answerStatistics.filter(function(obj) { return obj.taskAnswerId === r.ID; }) : 0,
                            count = (statistics[0]) ? statistics[0].answerCount : 0,
                            percentage = (count/total) * 100;

                        if (r.container) {
                            r.container.style.width = '100%';
                        }

                        if (r.inner) {
                            r.inner.style.width = percentage + '%';
                            r.inner.innerHTML = Math.floor(percentage) + '%';
                            r.inner.title = percentage.toFixed(5) + '%';
                        }
                    });

                } else if (type === 'progress') {
                    var inner,
                        container,
                        percentage = 0,
                        getProgress = function(r, res) {
                            var count = 0,
                                total = 0;

                            res.forEach(function(s) {
                                if (s.questionId !== r.questionID) {
                                    return;
                                }

                                total += s.answerCount;

                                if (s.taskAnswerId === r.ID) {
                                    count += s.answerCount;
                                }
                            });

                            return {
                                count: count,
                                total: total
                            }

                        };

                    results.forEach(function(r) {
                        var progress = getProgress(r, res.answerStatistics)

                        if (!progress.count) {
                            return;
                        }

                        container = r.container;
                        inner = (container || document).querySelector('.js-statistics-progress-inner');
                        percentage = (progress.count/progress.total) * 100;

                        if (container) {
                            container.style.width = percentage + '%';
                        }

                        if (inner) {
                            inner.innerHTML = Math.floor(percentage) + '%';
                            inner.title = percentage.toFixed(5) + '%';
                        }
                    });

                    items = [];

                } else if (type === 'pie') {

                    require(['graph'], function(graph) {

                        if (pie[0] && pie[0].label) {
                            self.pieLabel(pie[0].label);
                        }

                        graph.createPieChart({
                            colors: self.colors(),
                            interaction: (pie[0] && !!pie[0].interaction === false) ? false : true,
                            result: results,
                            response: res,
                            transition: transition,
                            answers: trainingVM.computedAnswers()
                        });

                        items = [];

                    });
                }


            }).catch(function(err) {
                if (dataContext.debugMode) {
                    console.dir(err);
                }
            });

        }
    };

});

